import React, { ChangeEvent } from 'react';
import { useKSK2110_R01Store } from './Store_KSK2110_R01';
import { inputFormHeightOption } from 'src/components/common/common';
import { InfoFieldHandlers } from 'src/types/info-form';
import { CodeForm } from 'src/components/common/form/CodeForm';

interface Props {
	setSearchTrigger: (value: boolean) => void;
	handleChange: (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => void;
	handleFetchLotList: () => void;

	getProductWorkFieldHandlers: (fieldName: string) => InfoFieldHandlers;
}

export const InputForm_KSK2110_R01 = (props: Props) => {

	const {
		setSearchTrigger,
		handleChange,
		getProductWorkFieldHandlers,
	} = props;

	const {
		editKSK2110_R01,
	} = useKSK2110_R01Store();

	return (
        <div className="w-full flex flex-wrap items-center gap-[0px]">
			<CodeForm
				// 기존: label="공정지시" / value·name=productWorkNo
				label="작업지시"
				value={editKSK2110_R01?.productOrderNo || ""}
				custNmValue={editKSK2110_R01?.itemNm || ""}
				editable={true}
				custNmInputless={true}
				name="productOrderNo"
				handleChange={handleChange}
				onDoubleClick={(e) => {
					getProductWorkFieldHandlers('productOrderNo').onDoubleClick(e);
				}}
				onKeyDown={(e) => {
					getProductWorkFieldHandlers('productOrderNo').onEnterKeyDown(e);
				}}
				wrapperOption={{
					wrapperStyle: "w-[540px] min-w-[540px] mb-[4px]",
					titleStyle: "w-[150px] min-w-[150px] text-left",
					codeInputStyle: "w-[380px] min-w-[380px] " + inputFormHeightOption,
					custNmInputStyle: "w-[105px] min-w-[105px]"
				}}
			/>
            
            <button 
                className={`text-white bg-blue-dark items-center justify-center px-[8px] py-[2px] rounded-[4px] w-[74px] mb-[4px] flex-shrink-0 ${inputFormHeightOption}`}
                onClick={() => {
					setSearchTrigger(true);
				}}
            >
                조회
            </button>
        </div>
    );
}
